import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, SnackbarService } from "@/services";
import { BriefcaseFolder, VignetteHelpers } from "@/types";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteBriefcaseFolderDialog',
  props: {
    folder: null
  },
  emits: ["close", "deleted"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close", isViewingFolderToDelete: boolean): void;
  (e: "deleted"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  folder: BriefcaseFolder;
};



const folderName = computed(() => props.folder?.name ?? "");



const deleteFolder = async () => {
  const response = await ApiService.postBriefcaseFolderDelete(props.folder.id);

  if (response.statusCode === 200) {
    VignetteHelpers.Analytics.push({
      ["event"]: "briefcase-delete-folder",
    });
    SnackbarService.displaySnackbar("Folder deleted.", "primary");
    emit("deleted");
  } else {
    SnackbarService.displaySnackbar("An error occurred. Please try again.");
  }
};

return { __sfc: true,props, folderName, emit, deleteFolder, NjBtn }
}

})